import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ToggleRow from '../../../../components/toggle-row/ToggleRow';
import SmallJSONEditor from '../../../../components/small-json-editor/SmallJSONEditor';
import ValidationService from '../../../../services/ValidationService';
import RESTService from '../../../../services/RESTService';
import Dropdown from '../../../../components/dropdown/Dropdown';
import RoutingService from '../../../../services/RoutingService';
import ComponentHelper from '../../../../supers/ComponentHelper';
import TestRunnerModal from '../../../../components/test-runner-modal/TestRunnerModal';
import SampleRequestCard from '../../../../components/sample-request-card/SampleRequestCard';
import CommonService from '../../../../services/CommonService';
import _ from 'lodash';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();

class HttpConnector extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = this.defaultState();
		this.autoBind(['buildTypeDefault', 'scanForParams', 'onSetEmpty', 'onClearValue', 'onDefaultChange', 'getIsDisabled']);
		this.scanForParams();
	}

	defaultState = () => {
		if (this.props.connection) {
			return this.onBuildConnectionState(this.props.connection);
		}
		return {
			authOpen: false,
			headersOpen: false,
			agents: [],
			bodyOpen: false,
			formOpen: false,
			queryOpen: false,
			sslOpen: true,
			agentsOpen: false,
			parseJson: true,
			testing: false,
			path: '',
			actionType: 'get',
			authType: 'basic',
			headers: '',
			bodyContent: '',
			formContent: '',
			queryContent: '',
			agentContent: '',
			username: '',
			password: '',
			name: '',
			url: '',
			token: '',
			timeout: 0,
			runningTest: false,
			requestParams: {},
			disabled: {}
		};
	};

	componentDidMount() {
		connect.getAgents().then(res => {
			this.setData('agents', res.data);
		});
	}

	isValidConnection = () => {
		let data = this.data;

		if (data.name.length === 0) {
			return true;
		}

		if (data.url.length === 0) {
			return true;
		}

		if (data.authOpen) {
			if (data.authType === 'basic') {
				if (data.username.length === 0 && data.password === 0) {
					return true;
				}
			} else if (data.authType === 'bearer') {
				if (data.token.length === 0) {
					return true;
				}
			}
		}

		if (data.headersOpen) {
			if (data.headers.length === 0) {
				return true;
			}
		}

		if (data.bodyOpen) {
			if (data.bodyContent.length === 0) {
				return true;
			}
		}

		if (data.formOpen) {
			if (data.formContent.length === 0) {
				return true;
			}
		}

		if (data.queryOpen) {
			if (data.queryContent.length === 0) {
				return true;
			}
		}

		return false;
	};

	onCreateConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		if (this.props.connection) {
			delete connection.type;
			connect
				.updateConnection(connection)
				.then(res => {
					this.observe(() => {
						this.data = this.onBuildConnectionState(res.data);
					});
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
				});
		} else {
			connect
				.createConnection(connection)
				.then(() => {
					RS.showSuccess();
					RS.goToRoute('/connections');
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	onBuildConnectionState(conn) {
		let config = conn.configuration;
		let auth = config.auth;
		let state = {
			testing: conn.testing,
			actionType: 'get',
			agents: this.data.agents ? this.data.agents : [],
			authOpen: auth ? true : false,
			headersOpen: config.headers ? true : false,
			bodyOpen: config.body ? true : false,
			formOpen: config.form ? true : false,
			queryOpen: config.qs ? true : false,
			sslOpen: config.strictSSL,
			agentsOpen: conn.agent && conn.agent.length > 0 ? true : false,
			parseJson: config.json,
			path: config.path ? config.path : '',
			authType: auth ? auth.type : 'basic',
			headers: config.headers ? JSON.stringify(config.headers, undefined, 2) : '',
			bodyContent: config.body ? JSON.stringify(config.body, undefined, 2) : '',
			formContent: config.form ? JSON.stringify(config.form, undefined, 2) : '',
			queryContent: config.qs ? JSON.stringify(config.qs, undefined, 2) : '',
			agentContent: conn.agent && conn.agent.length > 0 ? conn.agent : '',
			username: auth ? auth.username : '',
			password: auth ? auth.password : '',
			name: conn.name,
			url: config.url,
			token: auth ? auth.token : '',
			timeout: conn.timeout ? Number(conn.timeout) : 0,
			runningTest: false,
			requestParams: {}
		};

		let disabled = {};
		if (state.testing || this.props.endpoint) {
			if (state.path.length > 0) {
				disabled.path = true;
			}
			if (state.url.length > 0) {
				disabled.url = true;
			}
			if (state.authOpen) {
				disabled.auth = true;
			}
			if (state.headers.length > 0) {
				disabled.headers = true;
			}
			if (state.bodyContent.length > 0) {
				disabled.body = true;
			}
			if (state.formContent.length > 0) {
				disabled.form = true;
			}
			if (state.queryContent.length > 0) {
				disabled.qs = true;
			}
			if (state.agentsOpen) {
				disabled.agent = true;
			}
		}
		state.disabled = disabled;
		return state;
	}

	onClearConnection = () => {
		this.observe(() => {
			this.data = this.defaultState();
		});
	};

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.observe(() => {
			this.data[name] = value;
			this.scanForParams();
		});
	};

	onAuthChange = evt => {
		this.setData('authType', evt.value);
	};

	onActionChange = evt => {
		this.setData('actionType', evt.value);
	};

	onChecked = evt => {
		const { dataset, checked } = evt.target;
		this.setData(dataset.name, checked);
	};

	onToggleParse = () => {
		this.setData('parseJson', !this.data.parseJson);
	};

	handleHeadersChange = newValue => {
		this.observe(() => {
			this.data.headers = newValue;
			this.scanForParams();
		});
	};

	handleBodyChange = newValue => {
		this.observe(() => {
			this.data.bodyContent = newValue;
			this.scanForParams();
		});
	};

	handleFormChange = newValue => {
		this.observe(() => {
			this.data.formContent = newValue;
			this.scanForParams();
		});
	};

	handleQueryChange = newValue => {
		this.observe(() => {
			this.data.queryContent = newValue;
			this.scanForParams();
		});
	};

	toggleTestRunner = () => {
		this.setData('runningTest', !this.data.runningTest);
	};

	runTest = () => {
		this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		this.observe(() => {
			this.data.runningTest = true;
		});
	};

	onBuildConnection = () => {
		this.invalidForm = false;
		let data = this.data;
		let connection = {
			name: data.name,
			type: 'http-connector',
			configuration: {
				url: data.url,
				json: data.parseJson,
				strictSSL: data.sslOpen
			}
		};
		if (data.path.length > 0) {
			connection.configuration.path = data.path;
		}
		if (data.timeout >= 0) {
			connection.timeout = data.timeout;
		}
		if (data.authOpen) {
			connection.configuration.auth = {
				type: data.authType
			};
			if (data.authType === 'basic') {
				connection.configuration.auth.username = data.username;
				connection.configuration.auth.password = data.password;
			} else if (data.authType === 'bearer') {
				connection.configuration.auth.token = data.token;
			}
		}
		if (data.headersOpen) {
			if (data.headers.length > 0) {
				let val = CS.safelyParseJSON(data.headers);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.headers = val;
			}
		}
		if (data.bodyOpen) {
			if (data.bodyContent.length > 0) {
				let val = CS.safelyParseJSON(data.bodyContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.body = val;
			}
		}
		if (data.formOpen) {
			if (data.formContent.length > 0) {
				let val = CS.safelyParseJSON(data.formContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.form = val;
			}
		}
		if (data.queryOpen) {
			if (data.queryContent.length > 0) {
				let val = CS.safelyParseJSON(data.queryContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.qs = val;
			}
		}
		if (data.agentsOpen) {
			connection.agent = data.agentContent;
		} else {
			connection.agent = '';
		}
		return connection;
	};

	getIsDisabled(field) {
		return this.data.disabled[field];
	}

	buildTestConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			return false;
		}
		let is = this.onBuildConnectionState(this.props.connection);
		let config = {};
		if (!is.authOpen && this.data.authOpen) {
			config.auth = connection.configuration.auth;
		}
		if (!is.bodyOpen && this.data.bodyOpen) {
			config.body = connection.configuration.body;
		}
		if (!is.headersOpen && this.data.headersOpen) {
			config.headers = connection.configuration.headers;
		}
		if (!is.formOpen && this.data.formOpen) {
			config.form = connection.configuration.form;
		}
		if (!is.queryOpen && this.data.queryOpen) {
			config.qs = connection.configuration.qs;
		}
		if (!is.path && this.data.path) {
			config.path = connection.configuration.path;
		}
		let testData = CS.buildRequestTestData(this.data.requestParams);
		testData._async = this.data.async ? true : false;
		return {
			application: 'global',
			sandbox: RS.getCurrentEnvironment(),
			endpoint: {
				connection: connection.name,
				type: 'operation',
				action: this.data.actionType,
				configuration: config,
				templates: CS.buildRequestTemplate(this.data.requestParams)
			},
			testValues: testData
		};
	};

	onTestConnection = () => {
		return connect.testConnection(this.buildTestConnection());
	};

	scanForParams() {
		let keys = ['path', 'url', 'queryContent', 'formContent', 'bodyContent', 'headers'];
		this.data.requestParams = CS.buildRequestParams(keys, this.data);
		if (this.props.endpointWatcher) {
			this.props.endpointWatcher({
				cmp: this,
				data: this.data,
				builder: this.buildTestConnection
			});
		}
	}

	onSetEmpty(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = '';
			});
		}
	}

	onClearValue(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = undefined;
			});
		}
	}

	onDefaultChange(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field = this.data.requestParams[name];
				field.value = evt.target.value;
				this.data.requestParams[name] = field;
			});
		}
	}

	buildTypeDefault(details, param) {
		return (
			<div className="inline-btn-input hbox vcenter default">
				<input
					className="text-input"
					type="text"
					placeholder={details.value === '' ? 'Empty String' : 'None'}
					value={details.value}
					data-name={param}
					onChange={this.onDefaultChange}
				/>
				<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
					Set as empty
				</button>
				<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
					Clear
				</button>
			</div>
		);
	}

	toggleAsync = () => {
		this.setData('async', !this.data.async);
	};

	onAgentChange = evt => {
		if (evt.value) {
			this.setData('agentContent', evt.value);
		}
	};

	getAgentOptions = () => {
		let agents = [];
		_.forEach(this.data.agents, ag => {
			agents.push({
				label: ag.name,
				value: ag.name
			});
		});
		return agents;
	};

	render() {
		let {
			testing,
			actionType,
			agentsOpen,
			agentContent,
			authOpen,
			authType,
			headersOpen,
			headers,
			name,
			path,
			timeout,
			url,
			bodyOpen,
			bodyContent,
			formContent,
			formOpen,
			queryContent,
			queryOpen,
			sslOpen,
			parseJson,
			username,
			token,
			runningTest,
			password,
			async
		} = this.data;
		return (
			<div className="http-connector-cmp">
				<div className="step-card shadow animated fadeIn">
					<div className="hbox">
						<InputField
							label="Name"
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							name="name"
							value={name}
							handleChange={this.onValueChange}
							disabled={this.props.connection ? true : false}
							required
							autoFocus
						/>
						<div className="hbox vcenter checkbox-col">
							<input type="checkbox" checked={parseJson} onChange={this.onToggleParse} disabled={testing} />
							<div className="label">Parse JSON response</div>
						</div>
					</div>
					<InputField
						className="m-r-20"
						label="URL"
						subText="Base URL or host for the Exchange instance."
						type="text"
						name="url"
						value={url}
						handleChange={this.onValueChange}
						required
						disabled={this.getIsDisabled('url')}
					/>
					<div className="hbox field-ctn">
						<InputField
							label="Path"
							subText="Path to append to the base URL."
							type="text"
							name="path"
							className="m-r-20"
							value={path}
							disabled={this.getIsDisabled('path')}
							handleChange={this.onValueChange}
						/>
						<InputField
							name="timeout"
							label="Timeout"
							value={timeout}
							handleChange={this.onValueChange}
							subText="Optional time to wait for the response headers in milliseconds. This must be lower than the global Platform timeout (10s)."
							type="number"
						/>
					</div>
					<ToggleRow
						name="User Authentication"
						details="Enable if the REST service requires authentication."
						toggleOn={authOpen}
						keyName={'authOpen'}
						disabled={this.getIsDisabled('auth')}
						onToggle={this.onChecked}
						content={
							<div className="auth-content hbox vcenter">
								<Dropdown
									className="auth-dd m-r-20"
									label="Type"
									value={authType}
									handleChange={this.onAuthChange}
									name="authType"
									disabled={this.getIsDisabled('auth')}
									options={[
										{
											label: 'Basic',
											value: 'basic'
										},
										{
											label: 'Bearer',
											value: 'bearer'
										}
									]}
								/>
								{authType === 'basic' && [
									<InputField
										className="m-r-20"
										key="http-connector-username-key"
										label="Username"
										type="text"
										name="username"
										value={username}
										disabled={this.getIsDisabled('auth')}
										handleChange={this.onValueChange}
									/>,
									<InputField
										className="m-r-20"
										key="http-connector-password-key"
										label="Password"
										type="password"
										name="password"
										value={password}
										disabled={this.getIsDisabled('auth')}
										handleChange={this.onValueChange}
									/>
								]}
								{authType === 'bearer' && (
									<InputField
										className="m-r-20"
										label="Token"
										type="text"
										name="token"
										value={token}
										handleChange={this.onValueChange}
										disabled={this.getIsDisabled('auth')}
									/>
								)}
							</div>
						}
					/>
					<ToggleRow
						name="Headers"
						details={
							this.props.endpoint
								? 'Define any specific header required by the REST service.'
								: "Note that if you define headers at connection-level you won't be able to define any header at endpoint-level."
						}
						toggleOn={headersOpen}
						keyName={'headersOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						disabled={this.getIsDisabled('headers')}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor name="headers" value={headers} onChange={this.handleHeadersChange} readOnly={this.getIsDisabled('headers')} />
								<div className="json-message">Define headers as JSON, using keys for the header names and values for header values.</div>
							</div>
						}
					/>
					<ToggleRow
						name="Body"
						details={
							this.props.endpoint
								? 'Data to be sent to the external service in the request body.'
								: "Note that if you define a body at connection-level you won't be able to re-define it at endpoint-level."
						}
						toggleOn={bodyOpen}
						keyName={'bodyOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						disabled={this.getIsDisabled('body')}
						content={
							<div className="body-content vbox vcenter">
								<SmallJSONEditor name="body" value={bodyContent} onChange={this.handleBodyChange} readOnly={this.getIsDisabled('body')} />
								<div className="json-message">The request body must be defined as a valid JSON object.</div>
							</div>
						}
					/>
					<ToggleRow
						name="Form"
						details={
							this.props.endpoint
								? 'Data to be sent to the external service as url-encoded key/value (application/x-www-form-urlencoded)'
								: "Note that if you define form data at connection-level you won't be able to re-define it at endpoint-level."
						}
						disabled={this.getIsDisabled('form')}
						toggleOn={formOpen}
						keyName={'formOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="form-content vbox vcenter">
								<SmallJSONEditor name="form" value={formContent} onChange={this.handleFormChange} readOnly={this.getIsDisabled('form')} />
								<div className="json-message">The request form must be defined as a valid JSON object.</div>
							</div>
						}
					/>
					<ToggleRow
						name="Query String"
						details={
							this.props.endpoint
								? 'Optional query string to append to the execution URL.'
								: "Note that if you define a query string at connection-level you won't be able to define it at endpoint-level."
						}
						toggleOn={queryOpen}
						keyName={'queryOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						disabled={this.getIsDisabled('qs')}
						content={
							<div className="body-content vbox vcenter">
								<SmallJSONEditor name="query" value={queryContent} onChange={this.handleQueryChange} readOnly={this.getIsDisabled('qs')} />
								<div className="json-message">
									Define the query string as JSON, using keys for the variable names and values for variables values.
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="SSL Certificate Validation"
						details="The SSL validation can be disabled altogether in order to request servers using a certificate signed by an unknown Certificate Authority or a self-signed certificate. This is insecure and is recommended for testing purposes only."
						toggleOn={sslOpen}
						keyName={'sslOpen'}
						onToggle={this.onChecked}
						offContent={
							<div className="json-message">
								<i className="mdi mdi-alert" /> Insecure
							</div>
						}
					/>
					{!this.props.endpoint && (
						<ToggleRow
							name="Use an On-premise agent"
							details={
								'An agent is a process that runs in a virtual machine installed in a secure network. Once configured, it establishes a Web Socket connection with the Core Services platform, enabling the use of connectors that would otherwise be unreachable from the cloud.'
							}
							toggleOn={agentsOpen}
							keyName={'agentsOpen'}
							onToggle={this.onChecked}
							disabled={this.getIsDisabled('agent')}
							content={
								<div className="body-content vbox vcenter">
									<Dropdown
										className="w-100"
										label="Agent"
										value={agentContent}
										handleChange={this.onAgentChange}
										name="agentContent"
										disabled={this.getIsDisabled('agent')}
										options={this.getAgentOptions()}
									/>
								</div>
							}
						/>
					)}
					{testing &&
						!this.props.endpoint && (
							<div className="test-ctn vbox">
								<SampleRequestCard
									requestParams={this.data.requestParams}
									buildRequestFields={this.buildTypeDefault}
									validTest={true}
									onTest={this.runTest}
									async={async}
									toggleAsync={this.toggleAsync}
									content={
										<div className="hbox hright">
											<Dropdown
												className="test-action-dd"
												label="Test Action"
												value={actionType}
												handleChange={this.onActionChange}
												name="actionType"
												options={[
													{
														label: 'GET',
														value: 'get'
													},
													{
														label: 'POST',
														value: 'post'
													},
													{
														label: 'PUT',
														value: 'put'
													},
													{
														label: 'PATCH',
														value: 'patch'
													},
													{
														label: 'DELETE',
														value: 'delete'
													}
												]}
											/>
										</div>
									}
								/>
								<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestConnection} async={async} />
							</div>
						)}
					<div className={`btn-ctn ${this.props.endpoint ? 'hidden' : ''}`}>
						<button className="btn m-r-20" onClick={this.onClearConnection}>
							{this.props.connection ? 'Undo Changes' : 'Clear'}
						</button>
						<button className="btn primary" onClick={this.onCreateConnection} disabled={this.isValidConnection()}>
							{this.props.connection ? 'Save Connection' : 'Create Connection'}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default HttpConnector;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-creator/http-connector/HttpConnector.js